import { QuoteReservation } from '@/models/quote'

export const normalizeReservation = (reservation: QuoteReservation) => ({
  name: reservation.spotName,
  subType: reservation.spotType,
})
